import { ForemanPromocodesList, PromoPaginationParams } from '@my-account/const';
import { StateUtils } from '@spartacus/core';
import { FOREMAN_PROMOCODES_LIST } from '../my-account-state';

export const LOAD_FOREMAN_PROMOCODES = '[MyAccount] Load Foreman Promocodes';
export const LOAD_FOREMAN_PROMOCODES_SUCCESS = '[MyAccount] Load Foreman Promocodes Success';
export const LOAD_FOREMAN_PROMOCODES_FAIL = '[MyAccount] Load Foreman Promocodes Fail';
export const LOAD_FOREMAN_PROMOCODES_RESET = '[MyAccount] Load Foreman Promocodes Reset';

export class LoadForemanPromocodes extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_FOREMAN_PROMOCODES;

  constructor(public payload: PromoPaginationParams) {
    super(FOREMAN_PROMOCODES_LIST);
  }
}

export class LoadForemanPromocodesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_FOREMAN_PROMOCODES_SUCCESS;

  constructor(public payload: ForemanPromocodesList) {
    super(FOREMAN_PROMOCODES_LIST);
  }
}

export class LoadForemanPromocodesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_FOREMAN_PROMOCODES_FAIL;

  constructor() {
    super(FOREMAN_PROMOCODES_LIST);
  }
}

export class LoadForemanPromocodesReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_FOREMAN_PROMOCODES_RESET;

  constructor() {
    super(FOREMAN_PROMOCODES_LIST);
  }
}

export type ForemanPromocodesListActions =
  | LoadForemanPromocodes
  | LoadForemanPromocodesSuccess
  | LoadForemanPromocodesFail
  | LoadForemanPromocodesReset;
